import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { ForgotCredentialsComponentComponent } from './components';
import { IncidentAccidentDetailsPublicComponent } from './components/incident-accident/public/incident-accident-details-public.component';
import { IncidentAccidentPublicComponent } from './components/incident-accident/public/incident-accident-public.component';
import { IssueWebConfirmationComponent } from './components/IssueWeb/public/issue-web-confirmation/issue-web-confirmation.component';
import { IssueWebCreatePublicComponent } from './components/IssueWeb/public/issue-web-create-public/issue-web-create-public.component';
import { UpdateInfoComponent } from './components/tenants/public/update-info.component';
import { LoansConfirmComponent } from './loans/components/loans-confirm/loans-confirm.component';
import { AuthGuard } from './shared';
import { IssueGuard } from './shared/guard/issue.guard';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';

const routes: Routes = [
    { path: '', loadChildren: './components/layout/layout.module#LayoutModule', canActivate: [AuthGuard] },
    { path: 'login', loadChildren: './components/login/login.module#LoginModule' },
    { path: 'signup', loadChildren: './components/signup/signup.module#SignupModule' },
    { path: 'error', loadChildren: './components/server-error/server-error.module#ServerErrorModule' },
    { path: 'access-denied', loadChildren: './components/access-denied/access-denied.module#AccessDeniedModule' },
    { path: 'not-found', loadChildren: './components/not-found/not-found.module#NotFoundModule' },
    //WEB
    { path: 'confirm/loan', component: LoansConfirmComponent },
    { path: 'issues/:id/create', component: IssueWebCreatePublicComponent, canActivate: [IssueGuard] },
    { path: 'issues/:id/confirm-create', component: IssueWebConfirmationComponent },
    { path: 'forgot-password', component: ForgotCredentialsComponentComponent },
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: 'incident-accident/:id/create', component: IncidentAccidentPublicComponent },
    { path: 'contact/:id/update', component: UpdateInfoComponent },
    { path: 'IncidentAccidentDetails/:id', component: IncidentAccidentDetailsPublicComponent },
    { path: '**', redirectTo: 'not-found' },
];

@NgModule({
    imports: [FormsModule, RouterModule.forRoot(routes, { useHash: true, enableTracing: environment.name === "dev" })],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts